/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Injectable} from '@angular/core';
import {ApiConfig} from '../../api';
import {LocalNetworkProfile} from '../../../session/local-network-profile';
import {AdnHttpService} from '../../../util/adn-http.service';
import {AdnHttpSender, createAdnHttpResourceSender} from '../../../util/create-adn-http-resource';
import {AuthHttpInterceptorService} from '../../../auth/auth-http-interceptor.service';
import {ApiErrorHandlerService} from '../../../../app/common/directives/error/api-error-handler.service';



@Injectable()
export class VisitorProfileFields {
  private readonly uri = ApiConfig.obtain().getVersionedUri('visitorprofilefields');
  private readonly send: AdnHttpSender;

  constructor(
    private localNetworkProfile: LocalNetworkProfile,
    AdnHttp: AdnHttpService,
    authHttpInterceptor: AuthHttpInterceptorService,
    ApiErrorHandler: ApiErrorHandlerService
  ) {
    this.send = createAdnHttpResourceSender(AdnHttp, authHttpInterceptor, ApiErrorHandler);
  }

  get() {
    return this.send({
      method: 'GET',
      url: this.uri,
      params: {context: this.localNetworkProfile.getNetworkId()}
    }).then((data: any) => data.results);
  }
}
